"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientAuthStrategy = void 0;
const axios_1 = __importDefault(require("axios"));
const token_manager_1 = require("./token-manager");
class ClientAuthStrategy {
    constructor(options) {
        this.tokenManager = token_manager_1.TokenManagerProvider.getInstance();
        const authServiceUrl = options.authServiceUrl || window.authServiceUrl;
        if (!authServiceUrl) {
            throw new Error('Auth service URL is not provided');
        }
        this.clientId = options.clientId;
        this.authServiceUrl = authServiceUrl.replace(/^\/|\/$/g, '');
    }
    async getToken(forced = false) {
        const cachedToken = this.tokenManager.getToken(this.clientId);
        if (cachedToken && !forced) {
            return cachedToken;
        }
        try {
            const { data } = await axios_1.default.get('/api/account/token', {
                baseURL: this.authServiceUrl,
                params: { clientId: this.clientId },
                withCredentials: true
            });
            this.tokenManager.setToken(this.clientId, data.token);
            return data.token;
        }
        catch (e) {
            console.error(e);
            return null;
        }
    }
}
exports.ClientAuthStrategy = ClientAuthStrategy;
